import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollReveal from '@/components/base/ScrollReveal';
import CountUp from '@/components/base/CountUp';
import ParticleBackground from '@/components/base/ParticleBackground';

const regions = [
  { name: '美国', areas: '纽约 · 洛杉矶 · 硅谷', status: '战略布局中' },
  { name: '东南亚', areas: '新加坡 · 曼谷 · 雅加达', status: '市场拓展中' },
  { name: '日韩', areas: '东京 · 首尔', status: '内容分发中' },
  { name: '欧洲', areas: '伦敦 · 巴黎', status: '规划中' },
];

const services = [
  { icon: 'ri-lightbulb-flash-line', title: '海外IP孵化运营', desc: '基于中国文化资源，打造具有全球传播力的数字文化IP，实现海外本土化运营。' },
  { icon: 'ri-file-text-line', title: '传统文化内容深耕', desc: '将非遗技艺、历史故事、民俗风情等转化为适合海外传播的AIGC数字内容。' },
  { icon: 'ri-video-line', title: '短视频二创与分发', desc: '运用AI技术对文化内容进行短视频化改造，适配海外主流平台传播特性。' },
  { icon: 'ri-translate-2', title: '多语种本土化适配', desc: '提供英语、日语、韩语、泰语等多语种翻译与本土化适配服务。' },
  { icon: 'ri-bar-chart-line', title: '海外流量分发', desc: '基于数据驱动的海外流量分发策略，实现内容精准触达目标受众。' },
];

export default function Overseas() {
  return (
    <div className="ui-page">
      <Navbar />
      <main className="pt-20">
        <section className="relative py-20 md:py-28 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-background-900/40 to-transparent z-[1]"></div>
          <ParticleBackground compact />
          <div className="w-full px-4 md:px-8 lg:px-12 relative z-10">
            <div className="max-w-screen-2xl mx-auto">
              <ScrollReveal>
                <div className="text-center mb-16">
                  <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/10 border border-primary-500/20 mb-6">
                    <span className="w-1 h-1 rounded-full bg-primary-500"></span>
                    <span className="text-primary-300 text-xs font-medium tracking-wider whitespace-nowrap">Global Reach</span>
                  </div>
                  <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-primary-500 mb-6">文化出海</h1>
                  <p className="text-secondary-400 text-lg max-w-2xl mx-auto">山西故事文化出海计划 · 让中国文化被世界看见</p>
                </div>
              </ScrollReveal>

              {/* Stats */}
              <ScrollReveal>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-16">
                  {[
                    { value: 117, suffix: '', label: '县域文化资源源' },
                    { value: 5, suffix: '', label: '海外业务矩阵' },
                    { value: 4, suffix: '', label: '全球布局区域' },
                    { value: 5, suffix: '+', label: '目标语种覆盖' },
                  ].map((stat) => (
                    <div key={stat.label} className="group bg-background-900/50 rounded-2xl border border-primary-500/10 p-6 text-center hover:border-primary-500/25 hover:-translate-y-2 transition-all duration-500 hover:shadow-[0_0_30px_rgba(180,140,80,0.12)]">
                      <div className="font-heading text-3xl md:text-4xl font-bold text-primary-500 mb-2">
                        <CountUp end={stat.value} duration={2000} suffix={stat.suffix} />
                      </div>
                      <p className="text-secondary-400 text-xs md:text-sm">{stat.label}</p>
                    </div>
                  ))}
                </div>
              </ScrollReveal>

              <ScrollReveal>
                <div className="group bg-background-900/50 rounded-2xl border border-primary-500/15 p-8 md:p-12 mb-16 hover:border-primary-500/25 transition-all duration-500 hover:shadow-[0_0_30px_rgba(180,140,80,0.1)]">
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
                    <div>
                      <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-6 group-hover:text-primary-500 transition-colors duration-500">晋铧叙梦 · 山西故事文化出海计划</h2>
                      <div className="space-y-4 text-secondary-300 text-sm leading-relaxed">
                        <p>以<strong className="text-foreground-100 font-medium">山西117个县域文化资源</strong>为内容源，以<strong className="text-foreground-100 font-medium">AI数字光影内容</strong>为载体，将中华优秀传统文化转化为具有全球传播力的数字文化产品。</p>
                        <p>我们与<strong className="text-primary-500 font-semibold">图兰朵</strong>达成深度战略合作，依托其海外渠道资源与本土化运营能力，共同推进中国文化内容的全球化传播。</p>
                        <p>首批布局<strong className="text-foreground-100 font-medium">美国、东南亚</strong>等海外市场，以AIGC漫剧、仿真人短剧、文化纪录片、短视频二创等多元内容形态触达全球受众。</p>
                      </div>
                    </div>
                    <div className="relative">
                      <div className="aspect-square rounded-2xl bg-background-800/50 border border-primary-500/10 flex items-center justify-center relative overflow-hidden group-hover:border-primary-500/25 transition-all duration-500">
                        <div className="absolute inset-0 opacity-20">
                          <div className="absolute top-[30%] left-[25%] w-3 h-3 bg-primary-500 rounded-full animate-pulse"></div>
                          <div className="absolute top-[20%] right-[35%] w-3 h-3 bg-primary-500 rounded-full animate-pulse" style={{ animationDelay: '0.5s' }}></div>
                          <div className="absolute bottom-[35%] left-[40%] w-3 h-3 bg-accent-500 rounded-full animate-pulse" style={{ animationDelay: '1s' }}></div>
                          <div className="absolute bottom-[25%] right-[25%] w-3 h-3 bg-primary-500 rounded-full animate-pulse" style={{ animationDelay: '1.5s' }}></div>
                        </div>
                        <div className="relative z-10 text-center">
                          <i className="ri-global-line text-6xl text-primary-500/30 mb-4"></i>
                          <p className="text-secondary-400 text-sm">全球传播节点分布</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ScrollReveal>

              <ScrollReveal>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-10 text-center">海外业务矩阵</h2>
              </ScrollReveal>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
                {services.map((item) => (
                  <ScrollReveal key={item.title}>
                    <div className="group bg-background-900/50 rounded-2xl border border-primary-500/10 p-6 md:p-8 hover:border-primary-500/25 hover:-translate-y-2 transition-all duration-500 hover:shadow-[0_0_30px_rgba(180,140,80,0.12)]">
                      <div className="w-12 h-12 rounded-xl bg-primary-500/10 flex items-center justify-center mb-5 group-hover:bg-primary-500/20 group-hover:scale-110 transition-all duration-500">
                        <i className={`${item.icon} text-primary-500 text-xl`}></i>
                      </div>
                      <h3 className="text-foreground-50 font-semibold text-base mb-3 group-hover:text-primary-500 transition-colors duration-500">{item.title}</h3>
                      <p className="text-secondary-400 text-sm leading-relaxed">{item.desc}</p>
                    </div>
                  </ScrollReveal>
                ))}
              </div>

              <ScrollReveal>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-10 text-center">全球布局</h2>
              </ScrollReveal>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-16">
                {regions.map((item) => (
                  <ScrollReveal key={item.name}>
                    <div className="group bg-background-900/50 rounded-2xl border border-primary-500/10 p-6 text-center hover:border-primary-500/25 hover:-translate-y-2 transition-all duration-500 hover:shadow-[0_0_30px_rgba(180,140,80,0.12)]">
                      <h4 className="text-foreground-50 font-heading text-xl font-bold mb-2 group-hover:text-primary-500 transition-colors duration-500">{item.name}</h4>
                      <p className="text-secondary-400 text-xs mb-3">{item.areas}</p>
                      <span className="px-3 py-1 rounded-full bg-accent-500/10 border border-accent-500/20 text-accent-300 text-xs whitespace-nowrap group-hover:bg-accent-500/20 transition-all duration-500">{item.status}</span>
                    </div>
                  </ScrollReveal>
                ))}
              </div>

              <ScrollReveal>
                <div className="group text-center bg-background-900/50 rounded-2xl border border-primary-500/15 p-10 md:p-14 hover:border-primary-500/25 transition-all duration-500 hover:shadow-[0_0_30px_rgba(180,140,80,0.1)]">
                  <h3 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-4 group-hover:text-primary-500 transition-colors duration-500">携手推动中国文化出海</h3>
                  <p className="text-secondary-400 text-sm mb-8 max-w-xl mx-auto">我们欢迎海外合作伙伴、内容平台、文化机构与我们联手，共同推动中国文化内容的全球化传播。</p>
                  <a href="/cooperation" className="group/btn inline-flex items-center gap-2 px-8 py-3.5 bg-accent-500 text-foreground-50 font-medium rounded-full text-sm hover:bg-accent-400 transition-all duration-300 whitespace-nowrap cursor-pointer">
                    合作咨询
                    <div className="w-4 h-4 flex items-center justify-center transition-transform duration-300 group-hover/btn:translate-x-1">
                      <i className="ri-arrow-right-line"></i>
                    </div>
                  </a>
                </div>
              </ScrollReveal>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
